import React from 'react'

import {
  ToolbarClassic
} from './toolbars'

const Toolbar = () => {
  return <ToolbarClassic />
}

export {Toolbar}
